import { AxiosResponse } from "axios";
import API from "../api";
import { ServiceBooking } from "../models/service.booking";
import { IUploadCentreCreateMaterialList } from "../models/material";

const ROUTE_NAME = "materials";

const MaterialsService = {
  async count(options?: any): Promise<AxiosResponse<number>> {
    return await API.get(`/${ROUTE_NAME}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<ServiceBooking[]>> {
    return await API.get(`/${ROUTE_NAME}?sortBy=["name"]`, { params: options });
  },
  async create(material: ServiceBooking): Promise<AxiosResponse<ServiceBooking>> {
    return await API.post(`/${ROUTE_NAME}`, material);
  },
  async update(id: number, material: ServiceBooking): Promise<AxiosResponse<boolean>> {
    return await API.put(`/${ROUTE_NAME}/${id}`, material);
  },
  async postCSV(data: IUploadCentreCreateMaterialList[]): Promise<AxiosResponse<ServiceBooking[]>>{
    return await API.post(`/${ROUTE_NAME}/list`, data);
  },
};

export default MaterialsService;
